import {
  UserDispatchTypes,
  USER_LOADING,
  USER_SUCCESS,
  USER_FAILED,
  USER_WALLET_SUCCESS,
  USER_SET_TOTAL_ASSET,
  RESET_USER,
} from "../../actions/user/UserActionType";
import { ProfileModel } from "../../../models/Profile.model";

interface IDefaultState {
  loading: boolean;
  user?: ProfileModel;
  wallet: {
    accountId: string;
    assetValueStr: string;
    balance: number;
    balanceStr: string;
    blockedAmount: number;
    blockedAmountStr: string;
    creationTime: number;
    currency: string;
    currencyResponseDto: {
      currencyPriority: string;
      currencyType: string;
      iconUrl: string;
      id: number;
      minWithdrawExecute: number;
      name: string;
      nameEn: string;
      nameFa: string;
      networks: { address: string }[];
      scale: number;
    };
    effectiveBalance: number;
    effectiveBalanceStr: string;
    id: number;
    networks: { address: string }[];
    updateTime: null | number;
    userId: string;
    username: string;
  }[];
  totalAsset: number;
}

const defaultState: IDefaultState = {
  loading: false,
  totalAsset: 0,
  wallet: [],
};

const UserReducer = (
  // eslint-disable-next-line no-restricted-globals
  state: IDefaultState = defaultState,
  action: UserDispatchTypes
): IDefaultState => {
  switch (action.type) {
    case USER_FAILED:
      return {
        ...state,
        loading: false,
      };
    case USER_LOADING:
      return {
        ...state,
        loading: true,
      };
    case USER_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload.user,
      };
    case USER_WALLET_SUCCESS:
      return {
        ...state,
        loading: false,
        wallet: action.payload.wallet,
      };
    case USER_SET_TOTAL_ASSET:
      return {
        ...state,
        loading: false,
        totalAsset: action.payload.totalAsset,
      };
    case RESET_USER:
      return defaultState;
    default:
      return state;
  }
};

export default UserReducer;
